import React from "react";

const CloseModal = ({ handleClose }) => (
  <button className="react-modal-close" onClick={handleClose} type="button">
    <i className="icon-times" />
  </button>
);

export default CloseModal;
